const displayBookedLessonStateForStudents = (bookedLessonState) => {
  if (bookedLessonState === 'Lesson booked') {
    return 'Bài học đã được đặt'
  } else if (bookedLessonState === 'Lesson confirmed by teacher') {
    return 'Bài học đã được xác nhận bởi giáo viên'
  } else if (bookedLessonState === 'Lesson succeeded') {
    return 'Bài học đã thành công'
  } else if (bookedLessonState === 'Lesson reviewed') {
    return 'Người học đã gửi nhận xét về bài học'
  } else if (bookedLessonState === 'Lesson has been canceled by teacher') {
    return 'Bài học đã bị hủy bỏ bởi giáo viên'
  } else if (bookedLessonState === 'Student complained about the lesson') {
    return 'Người học đã gửi khiếu nại về bài học'
  }
}

module.exports = displayBookedLessonStateForStudents